// extracted by mini-css-extract-plugin
export default {"container":"Ol-z","item":"Pl-z"};